import { TransferirPassageirosSubmitModel } from "../modelos/transferirPassageiros/submitModel";

export const INIT_TRANSFERIR_PASSAGEIROS_FORM_DATA: TransferirPassageirosSubmitModel = {
    idEvento: "",
    idOcorrencia: "",
    idPontoEmbarque: "",
    idsReservas: []
  };